import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patch } from '@truefit/http-utils';
import useCurrentGameId from '@/shared/hooks/useCurrentGameId';
import { ClipGroupModel, UpdateClipGroupInput } from '../types';

interface UpdateClipGroupParams {
  playbyplayId: string;
  clipGroupId: number;
  data: UpdateClipGroupInput;
}

const useUpdateClipGroupMutation = () => {
  const queryClient = useQueryClient();
  const gameId = useCurrentGameId();

  return useMutation({
    mutationFn: async ({ playbyplayId, clipGroupId, data }: UpdateClipGroupParams) => {
      const response = await patch<{ success: boolean; clipGroup: ClipGroupModel }>(
        `/v1.0/games/${gameId}/play-by-play/${playbyplayId}/clip-groups/${clipGroupId}`,
        data
      );
      return response.data.clipGroup;
    },
    onSuccess: (_, variables) => {
      // Invalidate the clip groups query for this play-by-play event
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'PlayByPlay', variables.playbyplayId, 'ClipGroups']
      });
      // Also invalidate game-level clip groups
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'ClipGroups']
      });
      // Invalidate clip group counts to update event action icons
      queryClient.invalidateQueries({
        queryKey: ['Games', gameId, 'ClipGroupCounts']
      });
    },
  });
};

export default useUpdateClipGroupMutation;
